<template>
  <input type="text" :disabled="disabled" class="form-control" :value="formattedCardNumber" @input="onInput"  />
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";

@Component({
  name: "PayoutCardnumberInput"
})
export default class PayoutCardnumberInput extends Vue{
  @Prop({default: ''})
  value: string

  @Prop({default: false})
  disabled

  get formattedCardNumber(){
    return this.formatCardNumber('' + this.value);
  }
  set formattedCardNumber(newValue: any) {
    this.$emit('input', this.formatCardNumber('' + newValue));
  }

  onInput(event: any) {
    this.formattedCardNumber = event.target.value;
    this.$forceUpdate();
  }

  formatCardNumber(number: string = ''): string {
    const v = number.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    const matches = v.match(/\d{5,}/g);
    const match = matches && matches[0] || '';
    const parts = [];

    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4))
    }
    if (parts.length) {
      return parts.join(' ')
    } else {
      return v
    }
  }
}
</script>

<style scoped>

</style>
